import { Component, OnInit } from '@angular/core';
import { Route, Router } from '@angular/router';
import { CommonCommunicationService } from 'src/app/core/services/commonCommunication.service';
import { CommonUtilityService } from 'src/app/core/services/commonUtility.service';
import { OrderService } from 'src/app/core/services/order.service';
import { ChartType } from '../dashboard/dashboard.model';
import { BestSelling } from '../dashboard/data';

@Component({
  selector: 'app-sales-dashboard',
  templateUrl: './sales-dashboard.component.html',
  styleUrls: ['./sales-dashboard.component.scss']
})
export class SalesDashboardComponent implements OnInit {

  constructor(
    private ccs: CommonCommunicationService,
    private orderService: OrderService,
    private commonUtilityService: CommonUtilityService,
    private router: Router
  ) { }

  statData: any[] = []
  analyticsChart!: ChartType;
  BestSelling: any;
  totalOrderChart: any;
  grossSellChart: any;
  activeShopId: any
  dateRange: any
  startDate: any = ''
  endDate: any = ''
  grossSellDate: any
  totalOrderDate: any
  grossSumList: any
  totalOrderSumList: any
  showClearFilterBtn: boolean = false
  filter: any
  modulePermission: any = {
    is_delete: true,
    is_write: true,
    is_update: true,
    is_view: true,
  }

  totalTransactionChart: any;
  totalTransactionData: any;
  paymentModeList: any;
  showDashboard: any = true
  ngOnInit(): void {

    this.ccs.getModuleList().subscribe(res => {
      if (res) {
        this.modulePermission = this.commonUtilityService.setModulePermission(res, "Sales Order")
        
        if (!this.modulePermission.is_view) {
          this.showDashboard = false
        }
      }
    })

    this.ccs.getActiveShopId().subscribe(res => {
      if (res) {
        this.activeShopId = res
        // this.fetchData()
        this.dateFilter('monthly')
      }
    })
  }

  fetchData() {
    this.statData = []
    this.BestSelling = BestSelling;
    this.getSalesDashboard()
    this.totalPurchaseCount()
    this.totalCreditCount()
    this.totalDebitCount()
    this.getTransactionData()
  }
  addDays(date: any, days: any) {
    const copy = new Date(Number(date))
    copy.setDate(date.getDate() + days)
    return copy
  }
  getSalesDashboard() {
    let payload = {
      "shop_id": this.activeShopId,
      "start_date": this.addDays(this.startDate, 1),
      "end_date": this.addDays(this.endDate, 1)
    }
    this.orderService.getSalesDashboard(payload).subscribe(res => {
      this.statData.push({
        title: 'AVERAGE ORDER',
        value: res.avgOrderPerDay,
        icon: 'bx bxs-shopping-bag',
        //   persantage: '29.08',
        //   profit: 'up'
      },)
      this.statData.push({
        title: 'AVERAGE ORDER SALE',
        value: res.avgSalePerDay,
        icon: 'ri-exchange-funds-line',
        //   persantage: '29.08',
        //   profit: 'up'
      },)
      this.statData.push({
        title: 'AVERAGE ORDER VALUE',
        value: res.avgOrderValue,
        icon: 'ri-exchange-dollar-line',
        //   persantage: '29.08',
        //   profit: 'up'
      },)
      this.getGrossSell(res.grossSaleGraph)
      this.getTotalOrder(res.totalOrdersGraph)
    })
  }

  getTransactionData() {
    let reqObj = {
      "shop_id": this.activeShopId,
      "start_date": this.startDate,
      "end_date": this.endDate
    }

    this.orderService.getTotalTransactionByPaymentMode(reqObj).subscribe((res) => {
      
      this.totalTransactionData = res;
      this.paymentModeList = Object.keys(this.totalTransactionData);
      this.getTotalTransaction()
    })

  }

  dateFilter(type: any) {
    this.filter = type
    this.endDate = new Date()
    let date = new Date

    switch (type) {
      case 'yearly':
        date.setFullYear(date.getFullYear() - 1);
        this.startDate = date
        this.fetchData()
        break
      case 'monthly':
        date.setMonth(date.getMonth() - 1);
        this.startDate = date
        this.fetchData()
        break
      case 'weakly':
        date.setDate(this.endDate.getDate() - 7);
        this.startDate = date
        this.fetchData()
        break
      case 'daily':
        date.setDate(this.endDate.getDate() - 1);
        this.startDate = date
        this.fetchData()
        break
    }
  }

  getGrossSell(grossSell: any) {
    let grossSum = []
    let dateList = []
    for (let i = 0; i < grossSell.length; i++) {
      let date = grossSell[i]._id.date + '/' + grossSell[i]._id.month + '/' + grossSell[i]._id.year
      dateList.push(date)
      grossSum.push(Math.ceil(grossSell[i].sum))
    }
    this.grossSellDate = dateList
    this.grossSumList = grossSum
    this._grossSaleChart('["--vz-primary", "--vz-gray-300"]');
  }
  getTotalOrder(totalOrder: any) {
    let totalSum = []
    let dateList = []
    for (let i = 0; i < totalOrder.length; i++) {
      let date = totalOrder[i]._id.date + '/' + totalOrder[i]._id.month + '/' + totalOrder[i]._id.year
      dateList.push(date)
      totalSum.push(Math.ceil(totalOrder[i].sum))
    }
    this.totalOrderDate = dateList
    this.totalOrderSumList = totalSum
    this._totalOrderChart('["--vz-success", "--vz-gray-300"]');
  }

  getTotalTransaction() {
    this._totalTransactionChart('["#524466", "#BD7BA9", "#84A5B8", "#FEE6C1", "#B2CFB0", "#84A5B8"]');
  }


  // Chart Colors Set
  private getChartColorsArray(colors: any) {
    colors = JSON.parse(colors);
    return colors.map(function (value: any) {
      var newValue = value.replace(" ", "");
      if (newValue.indexOf(",") === -1) {
        var color = getComputedStyle(document.documentElement).getPropertyValue(newValue);
        if (color) {
          color = color.replace(" ", "");
          return color;
        }
        else return newValue;;
      } else {
        var val = value.split(',');
        if (val.length == 2) {
          var rgbaColor = getComputedStyle(document.documentElement).getPropertyValue(val[0]);
          rgbaColor = "rgba(" + rgbaColor + "," + val[1] + ")";
          return rgbaColor;
        } else {
          return newValue;
        }
      }
    });
  }

  /**
 * Basic Column Charts
 */
  private _grossSaleChart(colors: any) {
    colors = this.getChartColorsArray(colors);
    this.grossSellChart = {
      series: [
        //   {
        //   name: 'Last Year',
        //   data: [25.3, 12.5, 20.2, 18.5, 40.4, 25.4, 15.8, 22.3, 19.2, 25.3, 12.5, 20.2]
        // }, 
        {
          name: 'Current Year',
          // data: [36.2, 22.4, 38.2, 30.5, 26.4, 30.4, 20.2, 29.6, 10.9, 36.2, 22.4, 38.2]
          data: this.grossSumList
        }],
      chart: {
        type: 'bar',
        height: 306,
        stacked: true,
        toolbar: {
          show: false,
        }
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '30%',
          borderRadius: 6,
        },
      },
      dataLabels: {
        enabled: false,
      },
      legend: {
        show: true,
        position: 'bottom',
        horizontalAlign: 'center',
        fontWeight: 400,
        fontSize: '8px',
        offsetX: 0,
        offsetY: 0,
        markers: {
          width: 9,
          height: 9,
          radius: 4,
        },
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['transparent']
      },
      grid: {
        show: false,
      },
      colors: colors,
      xaxis: {
        // categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        categories: this.grossSellDate,
        axisTicks: {
          show: false,
        },
      },
      yaxis: {
        title: {
          text: ''
        },
      },
      fill: {
        opacity: 1

      },
      tooltip: {
        y: {
          formatter: function (val: any) {
            return val
          }
        }
      }
    };
  }

  private _totalOrderChart(colors: any) {
    colors = this.getChartColorsArray(colors);
    this.totalOrderChart = {
      series: [
        //   {
        //   name: 'Last Year',
        //   data: [25.3, 12.5, 20.2, 18.5, 40.4, 25.4, 15.8, 22.3, 19.2, 25.3, 12.5, 20.2]
        // }, 
        {
          name: 'Current Year',
          // data: [36.2, 22.4, 38.2, 30.5, 26.4, 30.4, 20.2, 29.6, 10.9, 36.2, 22.4, 38.2]
          data: this.totalOrderSumList
        }],
      chart: {
        type: 'bar',
        height: 306,
        stacked: true,
        toolbar: {
          show: false,
        }
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '30%',
          borderRadius: 6,
        },
      },
      dataLabels: {
        enabled: false,
      },
      legend: {
        show: true,
        position: 'bottom',
        horizontalAlign: 'center',
        fontWeight: 400,
        fontSize: '8px',
        offsetX: 0,
        offsetY: 0,
        markers: {
          width: 9,
          height: 9,
          radius: 4,
        },
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['transparent']
      },
      grid: {
        show: false,
      },
      colors: colors,
      xaxis: {
        // categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        categories: this.totalOrderDate,
        axisTicks: {
          show: false,
        },
      },
      yaxis: {
        title: {
          text: ''
        },
      },
      fill: {
        opacity: 1

      },
      tooltip: {
        y: {
          formatter: function (val: any) {
            return val
          }
        }
      }
    };
  }

  private _totalTransactionChart(colors: any) {
    colors = this.getChartColorsArray(colors);
    let series = Object.values(this.totalTransactionData)
    this.totalTransactionChart = {
      series: series,
      labels: this.paymentModeList,
      chart: {
        type: "pie",
        height: 300,
      },
      plotOptions: {
        pie: {
          donut: {
            size: "76%",
          },
        },
      },
      dataLabels: {
        enabled: false,
      },
      legend: {
        show: false,
        position: 'bottom',
        horizontalAlign: 'center',
        offsetX: 0,
        offsetY: 0,
        markers: {
          width: 20,
          height: 6,
          radius: 2,
        },
        itemMargin: {
          horizontal: 12,
          vertical: 0
        },
      },
      stroke: {
        width: 0
      },
      yaxis: {
        labels: {
          formatter: function (value: any) {
            return value;
          }
        },
        tickAmount: 4,
        min: 0
      },
      colors: colors
    };
  }

  onFilter() {
    if (!this.dateRange) {
      this.commonUtilityService.showDanger('Please select any Date');
      return
    }
    this.showClearFilterBtn = true
    this.startDate = this.dateRange.from
    if (this.dateRange.to) {
      this.endDate = this.dateRange.to
    }
    else {
      this.endDate = this.dateRange.from
    }
    this.fetchData()
  }
  onClearFilter() {
    this.showClearFilterBtn = false
    this.dateRange = ''
    this.startDate = ''
    this.endDate = ''
    this.dateFilter('monthly')
  }

  private totalPurchaseCount() {
    let payload = {
      "shop_id": this.activeShopId,
      "start_date": this.addDays(this.startDate, 1),
      "end_date": this.addDays(this.endDate, 1),
      "approval_status": "",
    }
    this.orderService.getTotalPurchaseCount(payload).subscribe(res => {
      this.statData.push({
        title: 'TOTAL PURCHASE COUNT',
        value: res.totalPurchaseOrders,
        icon: 'bx bxs-shopping-bag',
        //   persantage: '29.08',
        //   profit: 'up'
      },)
      this.statData.push({
        title: 'TOTAL PURCHASE PRODUCT',
        value: res.totalPurchasedProducts,
        icon: 'bx bxs-shopping-bag',
        //   persantage: '29.08',
        //   profit: 'up'
      },)
    })
  }

  private totalCreditCount() {

    let payload = {
      "shop_id": this.activeShopId,
      "start_date": this.addDays(this.startDate, 1),
      "end_date": this.addDays(this.endDate, 1),
      "approval_status": "",
    }

    this.orderService.getTotalCreditCount(payload).subscribe(res => {
      this.statData.push({
        title: 'TOTAL CREDIT COUNT',
        value: res.totalCreditNotes,
        icon: 'bx bxs-shopping-bag',
        //   persantage: '29.08',
        //   profit: 'up'
      },)
    })
  }

  private totalDebitCount() {

    let payload = {
      "shop_id": this.activeShopId,
      "start_date": this.addDays(this.startDate, 1),
      "end_date": this.addDays(this.endDate, 1),
      "approval_status": "",
    }

    this.orderService.getTotalDebitCount(payload).subscribe(res => {
      this.statData.push({
        title: 'TOTAL DEBIT COUNT',
        value: res.totalDebitNotes,
        icon: 'bx bxs-shopping-bag',
        //   persantage: '29.08',
        //   profit: 'up'
      },)
    })
  }



}
